import getCurrentEventOrganizer from 'owa-calendar-compose-form-store/lib/selectors/getCurrentEventOrganizer';
import getFromAddress from '../utils/getFromAddress';
import getRecipientEmailAddress from 'owa-recipient-common/lib/utils/getRecipientEmailAddress';
import type SingleRecipientType from 'owa-service/lib/contract/SingleRecipientType';
import updateMailTipsForRecipients from 'owa-calendar-compose-form-actions/lib/actions/updateMailTipsForRecipients';
import { orchestrator } from 'satcheljs';
import { updateMailtips } from 'owa-mail-tips';
import type AttendeeType from 'owa-service/lib/contract/AttendeeType';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { logRecipientRemovedFromRecipientWellDatapoint } from 'owa-mail-tips/lib/datapoints';
import getMailTipsViewStateMapFromRecipientEmailAddress from 'owa-mail-tips/lib/utils/getMailTipsViewStateMapFromRecipientEmailAddress';

/**
 * Subscribe to the event addRecipientToRecipientWell dispatched by ReadWriteFabricRecipientWell
 * and update mailTips for the added recipient
 **/
export default orchestrator(updateMailTipsForRecipients, actionMessage => {
    const { recipients, isRequiredAttendee } = actionMessage;

    const organizer: SingleRecipientType = getCurrentEventOrganizer();
    const fromEmailAddress: string = getFromAddress(organizer);
    if (recipients?.length) {
        const recipientEmailAddresses = recipients.map(recipient => {
            return getRecipientEmailAddress(recipient);
        });
        updateMailtips(null, fromEmailAddress, recipientEmailAddresses);
    }

    // Log datapoint
    const store = getComposeStore();
    if (!store || !store.event) {
        return;
    }
    const persistedEmailAddresses = recipients.map(recipient =>
        getRecipientEmailAddress(recipient)
    );
    let attendees: AttendeeType[];

    if (isRequiredAttendee) {
        attendees = store.event.RequiredAttendees;
    } else {
        attendees = store.event.OptionalAttendees;
    }
    const removedAttendees = attendees.filter(
        attendee => !persistedEmailAddresses.includes(attendee.Mailbox.EmailAddress)
    );
    removedAttendees.forEach(attendee => {
        const mailTipViewState = getMailTipsViewStateMapFromRecipientEmailAddress(
            [attendee],
            fromEmailAddress
        );
        logRecipientRemovedFromRecipientWellDatapoint(mailTipViewState);
    });
});

export type { default as ReadWriteRecipientWellViewState } from 'owa-recipient-types/lib/types/ReadWriteRecipientWellViewState';
